import $ from 'jquery';

import PxsAnnouncementBar from '@pixelunion/pxs-announcement-bar';

export default class AnnouncementBar {
  constructor(instance) {
    this.$document = $(document.body);
    this.el = instance.el;
    this.announcementBar = new PxsAnnouncementBar(instance);
    this._checkAnnouncementBar();
  }

  onSectionUnload() {
    this.announcementBar.onSectionUnload();
    this._checkAnnouncementBar();
  }

  _checkAnnouncementBar() {
    this.announcementBarEl = this.el.querySelector('.pxs-announcement-bar');
    this.$document.trigger('checkAnnouncementBar', { el: this.announcementBarEl });
  }
}
